export default "__VITE_ASSET__CjZfHt2c__"